export default "__VITE_ASSET__DsTNC_1k__"